(() => {
  const exactIphoneModels = ['iPhone 7', 'iPhone 7 Plus', 'iPhone 8', 'iPhone 8 Plus', 'iPhone X', 'iPhone XS', 'iPhone XS Max', 'iPhone XR', 'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max', 'iPhone SE (2020)', 'iPhone SE (2022)', 'iPhone 12', 'iPhone 12 mini', 'iPhone 12 Pro', 'iPhone 12 Pro Max', 'iPhone 13', 'iPhone 13 mini', 'iPhone 13 Pro', 'iPhone 13 Pro Max', 'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max', 'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max', 'iPhone 16', 'iPhone 16e', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max', 'iPhone 17', 'iPhone 17e', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone Air', 'iPhone 18', 'iPhone 18 Pro', 'iPhone 18 Pro Max'];
  const exactModelUrl = (model) => `/collections/all?filter.p.m.tovynx.compatible_models=${encodeURIComponent(model)}`;

  const enhanceControls = () => {
    document.querySelectorAll('[data-tvx-model-select]').forEach((select) => {
      const iphone18Models = ['iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone 18'];
      const firstExistingModel = select.options[1] || null;
      iphone18Models.forEach((model) => {
        const alreadyExists = Array.from(select.options).some((option) => option.value === model);
        if (alreadyExists) return;
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model;
        select.insertBefore(option, firstExistingModel);
      });
    });

    const header = document.querySelector('.tovynx-header');
    if (header && !header.dataset.tvxMenuEnhanced) {
      header.dataset.tvxMenuEnhanced = 'true';

      const mobileDetails = header.querySelector('.tovynx-mobile-menu');
      const mobileNav = mobileDetails?.querySelector('nav');
      if (mobileDetails && mobileNav) {
        mobileDetails.addEventListener('toggle', () => {
          document.documentElement.classList.toggle('tvx-menu-open', mobileDetails.open);
        });
      }
    }

    document.querySelectorAll('[data-tvx-model-select]:not([data-tvx-ready])').forEach((select) => {
      select.dataset.tvxReady = 'true';
      const button = select.closest('.tvx-case-finder__control')?.querySelector('[data-tvx-model-go]');
      const memory = select.closest('.tvx-case-finder__control')?.querySelector('[data-tvx-model-memory]');
      select.value = '';
      try { localStorage.removeItem('tvxIphoneModel'); } catch (error) {}
      const updateFinder = () => {
        const model = select.value;
        if (!button) return;
        if (model) {
          button.href = exactModelUrl(model);
          button.classList.remove('is-disabled');
          button.removeAttribute('aria-disabled');
          if (memory) memory.textContent = `${model} selected — change it any time.`;
          // Keep the choice only for the current page; never preselect it on a future visit.
        } else {
          button.href = '/collections/all';
          button.classList.add('is-disabled');
          button.setAttribute('aria-disabled', 'true');
          if (memory) memory.textContent = 'Choose your model to see matching cases.';
        }
      };
      select.addEventListener('change', updateFinder);
      button?.addEventListener('click', (event) => {
        if (!select.value) {
          event.preventDefault();
          select.focus();
        }
      });
      updateFinder();
    });

    document.querySelectorAll('form.tvx-search__form:not([data-tvx-exact-model-ready])').forEach((form) => {
      form.dataset.tvxExactModelReady = 'true';
      form.addEventListener('submit', (event) => {
        const query = form.querySelector('input[name="q"]')?.value.trim();
        if (!query) return;
        const exactModel = exactIphoneModels.find((model) => model.toLowerCase() === query.toLowerCase());
        if (!exactModel) return;
        event.preventDefault();
        window.location.assign(exactModelUrl(exactModel));
      });
    });

    document.querySelectorAll('[data-tvx-mood-button]:not([data-tvx-ready])').forEach((button) => {
      button.dataset.tvxReady = 'true';
      button.addEventListener('click', () => {
        const section = button.closest('.tvx-section');
        section?.querySelectorAll('[data-tvx-mood-button]').forEach((item) => item.classList.toggle('is-active', item === button));
        const card = section?.querySelector(`[data-tvx-mood-card="${button.dataset.tvxMoodButton}"]`);
        section?.querySelectorAll('[data-tvx-mood-card]').forEach((item) => item.classList.toggle('is-picked', item === card));
        card?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    // Product cards already include the theme's native colour selector and swipe
    // gallery. Remove the old extra preview control so shoppers see one clear UI.
    document.querySelectorAll('#collection .tvx-card-swatches').forEach((controls) => controls.remove());

    if (document.body.classList.contains('template-product')) {
      document.querySelectorAll('.no-js-hidden > .tvx-model-picker').forEach((picker) => picker.remove());
      document.querySelectorAll('#cart .tvx-model-picker').forEach((picker) => picker.remove());
      document.querySelectorAll('#cart select.tvx-native-model-select').forEach((select) => {
        select.classList.remove('tvx-native-model-select');
        delete select.dataset.tvxModelPickerReady;
      });
      // Use the theme's native model selector only. Any older custom picker is removed above.
    }

    if (document.body.classList.contains('template-product') && !document.body.dataset.tvxViewedSaved) {
      document.body.dataset.tvxViewedSaved = 'true';
      const title = document.querySelector('#main-product h1')?.textContent.trim();
      const image = document.querySelector('#main-product .swiper-slide img')?.currentSrc || document.querySelector('#main-product .swiper-slide img')?.src;
      if (title && image) {
        try {
          const viewed = JSON.parse(localStorage.getItem('tvxRecentlyViewed') || '[]').filter((item) => item.url !== location.pathname);
          viewed.unshift({ title, image, url: location.pathname });
          localStorage.setItem('tvxRecentlyViewed', JSON.stringify(viewed.slice(0, 6)));
        } catch (error) {}
      }
    }

    document.querySelectorAll('.tvx-quick-bag').forEach((drawer) => drawer.remove());
    document.documentElement.classList.remove('tvx-bag-open');

    if (!document.documentElement.dataset.tvxRevealReady) {
      document.documentElement.dataset.tvxRevealReady = 'true';
      const revealItems = document.querySelectorAll('.tvx-section,.tvx-story,.tvx-find,.tvx-faq,.tvx-product-story,.tvx-complete-look,.tvx-cart-support');
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-tvx-visible');
            revealObserver.unobserve(entry.target);
          }
        }), { threshold: 0.08 });
        revealItems.forEach((item) => {
          item.classList.add('tvx-reveal');
          revealObserver.observe(item);
        });
      }
    }

    document.querySelectorAll('a.swiper-pagination-bullet:not([href]):not([data-tvx-keyboard])').forEach((control, index) => {
      control.dataset.tvxKeyboard = 'true';
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', `View product image ${index + 1}`);
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });
    });

    document.querySelectorAll('a:not([href])').forEach((control) => {
      if (!control.getAttribute('role')) control.setAttribute('role', 'button');
      if (!control.hasAttribute('tabindex')) control.setAttribute('tabindex', '0');
    });

    document.querySelectorAll('input.bv_input').forEach((input) => {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Search reviews');
    });

    const emptyCart = document.querySelector('body.template-cart .cart-empty');
    if (emptyCart) {
      const heading = emptyCart.querySelector('h1');
      const message = emptyCart.querySelector('p.m50');
      const continueLink = emptyCart.querySelector('a');
      if (heading) heading.textContent = 'Your bag is empty.';
      if (message) message.textContent = 'Find a case that feels like you and confirm your exact iPhone model before adding it to your bag.';
      if (continueLink) continueLink.setAttribute('href', '/collections/all');
    }

    document.querySelectorAll('body.template-cart button[name="checkout"]').forEach((button) => {
      button.setAttribute('aria-label', 'Checkout securely');
    });

    if (!document.documentElement.dataset.tvxCheckoutReady) {
      document.documentElement.dataset.tvxCheckoutReady = 'true';
      document.addEventListener('click', (event) => {
        const control = event.target instanceof Element ? event.target.closest('a,button,input[type="submit"]') : null;
        if (!control) return;
        if (control.matches('[data-tvx-checkout-via-cart]')) return;
        const label = (control.textContent || control.value || '').trim().replace(/\s+/g, ' ').toLowerCase();
        const href = control.getAttribute('href') || '';
        const isCheckout = control.matches('[data-tvx-direct-checkout]') ||
          control.getAttribute('name') === 'checkout' ||
          /(^|\/)checkout(?:[/?#]|$)/.test(href) ||
          label === 'checkout' || label === 'checkout securely';
        if (!isCheckout) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const checkoutForm = document.createElement('form');
        checkoutForm.action = '/cart';
        checkoutForm.method = 'post';
        checkoutForm.style.display = 'none';
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';
        checkoutForm.appendChild(checkoutInput);
        document.body.appendChild(checkoutForm);
        HTMLFormElement.prototype.submit.call(checkoutForm);
      }, true);
    }

    if (document.body.classList.contains('template-cart') && new URLSearchParams(window.location.search).get('tvx_checkout') === '1' && !document.body.dataset.tvxCheckoutForwarded) {
      document.body.dataset.tvxCheckoutForwarded = 'true';
      window.history.replaceState({}, '', '/cart');
      window.setTimeout(() => {
        const checkoutButton = document.querySelector('button[name="checkout"]');
        if (checkoutButton) checkoutButton.click();
      }, 350);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceControls, { once: true });
  } else {
    enhanceControls();
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      enhanceControls();
      scheduled = false;
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

